module.exports = __webpack_public_path__ + "img/icon_box_2_1.4d65d348.png";